import React from "react";
import { checkIconRed } from "../../../../assets/images/Icon";
import { CheckIconStyled, GridContainer, GridItem } from "../styled";

const Day = ({ data, setData }) => {
  const frequency = [
    "MOINS D’1 FOIS PAR SEMAINE",
    "1 à 3 FOIS",
    "4 à 6 FOIS",
    "WEEK-ENDS",
    "7 JOURS / 7",
    "JE NE SAIS PAS / DEMANDE PONCTUELLE",
  ];

  const handleClick = (item) => {
    setData({ ...data, frequency: item });
  };

  return (
    <GridContainer>
      {frequency.map((item, index) => (
        <GridItem
          selected={data.frequency === item}
          style={{ cursor: "pointer", padding: "0 1rem" }}
          onClick={() => {
            handleClick(item);
          }}
          key={index}
        >
          {data.frequency === item && <CheckIconStyled src={checkIconRed} />}
          {item}
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default Day;
